<template>
  <NotificationTemplate
    :notification="notification"
    class="notification__item-deleted"
  >
    <template #pic>
      <Avatar
        :src="notification.initiatorAvatarSrc || null"
        :gap="notification.getInitials()"
      />
    </template>
    <template #title>
      <BaseSubHeading
        size="large"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="400"
      >
        <span class="notification__update-item__initiator">
          {{ notification.initiatorFullName }}
        </span>
        <span class="notification__item-deleted__action">deleted Item</span>
        {{ locationPreposition }} {{ notification.deletedLocation }}
      </BaseSubHeading>
    </template>
    <template #content>
      <BaseSubHeading
        size="medium"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="500"
        className="notification__item-content notification__item-deleted__content"
      >
        <span
          v-if="itemTypeName"
          class="notification__item-deleted__type"
          :class="itemTypeClass"
        >
          {{ itemTypeName }}
        </span>
        {{ notification.itemSequenceNumber }}

        <BaseSubHeading
          size="medium"
          color="monochrome-06"
          darkColor="monochrome-03"
          weight="400"
          class="notification__item-content__title"
        >
          {{ notification.getItemValue("title") }}
        </BaseSubHeading>
      </BaseSubHeading>
    </template>
  </NotificationTemplate>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"
import { Prop } from "vue-property-decorator"

import Avatar from "@/components/Avatar/index.vue"
import NotificationTemplate from "@/components/Notification/NotificationTemplate.vue"

import { NotificationItemDeleted } from "@/models/Notification/NotificationItemDeleted"

@Options({
  name: "ITEM_DELETED",
  components: {
    Avatar,
    NotificationTemplate
  }
})
export default class ITEM_DELETED extends Vue {
  @Prop() readonly notification: NotificationItemDeleted

  get isInSprint() {
    const deletedItem = this.notification.deletedItem
    return !!deletedItem?.sprint?.id || !!deletedItem?.sprintSequenceNumber
  }

  get itemTypeName() {
    const itemType = this.notification.deletedItem?.itemType
    return itemType ? this.$t(`backlog.itemTypeToTitle.${itemType}`) : ""
  }

  get itemTypeClass() {
    const itemType = this.notification.deletedItem?.itemType
    return itemType ? `is-${itemType.toLowerCase()}` : ""
  }

  get locationPreposition() {
    return this.isInSprint ? "in" : "from"
  }
}
</script>
